import { tx, txt, useContent } from "@/content/ContentContext";
import { useEffect, useState } from "react";
import { Crown, MapPin, MessageCircle, QrCode, ReceiptText, Truck } from "lucide-react";
import { api } from "@/lib/api";
import { BACKEND, DEMO_STORE, storePath } from "@/lib/host";

const MEDIA = BACKEND;
const POINTS = () => ([
  [QrCode, tx("landing.your_own_store_link"), tx("landing.share_it_on_whatsapp_or")],
  [Truck, tx("landing.delivery_areas_pickup"), tx("landing.set_a_fee_per_area")],
  [MessageCircle, tx("landing.cash_on_delivery"), tx("landing.no_payment_setup_customers_pay")],
  [ReceiptText, tx("landing.orders_become_sales"), tx("landing.complete_an_order_and_it")],
]);

export function OnlineStoreSection() {
  useContent();
  const [shot, setShot] = useState(null);
  const [demo, setDemo] = useState(false);
  useEffect(() => { api.get(`/public/store/${DEMO_STORE}`).then((r) => setDemo(!!r.data.available)).catch(() => setDemo(false)); }, []);
  useEffect(() => { api.get("/how-it-works").then((r) => setShot(r.data.find((s) => s.id === "store_front") || null)).catch(() => {}); }, []);
  return (
    <section id="online-store" className="scroll-mt-20 overflow-hidden bg-stone-100" data-testid="landing-online-store">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 py-24 sm:px-8 lg:grid-cols-[1.1fr_0.9fr]">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-slate-950" data-testid="landing-online-store-badge">
            <Crown className="h-3.5 w-3.5" /> {txt("landing.premium")}
          </div>
          <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">{txt("landing.online_store_sell_beyond_the")}</h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-600">{txt("landing.publish_your_products_to_a")}</p>
          <div className="mt-8 grid gap-5 sm:grid-cols-2">
            {POINTS().map(([Icon, t, d]) => (
              <div key={t} className="flex gap-3">
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-slate-900 text-amber-400"><Icon className="h-5 w-5" /></span>
                <div><div className="font-display font-bold text-slate-900">{t}</div><p className="text-sm text-slate-600">{d}</p></div>
              </div>))}
          </div>
          {demo && <a href={storePath(DEMO_STORE)} target="_blank" rel="noreferrer" data-testid="landing-online-store-demo" className="mt-9 inline-flex items-center gap-2 rounded-full bg-slate-900 px-6 py-3 text-sm font-bold text-white hover:bg-slate-700">
            <MapPin className="h-4 w-4 text-amber-400" /> {txt("landing.see_a_live_demo_store")}
          </a>}
        </div>
        <div className="flex justify-center">
          <div className="relative w-[290px] rounded-[44px] border-[10px] border-slate-900 bg-slate-900 shadow-[0_40px_80px_-30px_rgba(15,23,42,0.6)]" data-testid="landing-online-store-phone">
            <div className="absolute left-1/2 top-2 z-10 h-5 w-24 -translate-x-1/2 rounded-full bg-slate-900" />
            <div className="aspect-[390/844] overflow-hidden rounded-[34px] bg-white">
              {shot ? <img src={`${MEDIA}${shot.image}`} alt={tx("landing.karachi_fresh_mart_online_store")} loading="lazy" className="h-full w-full object-cover object-top" data-testid="landing-online-store-shot" />
                : <div className="grid h-full place-items-center text-xs text-slate-400">{txt("landing.smart_in_online_store")}</div>}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
